import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PatientModel } from "../../Services/Models/Patient/PatientModel";
import { PatientState } from "./types";

const initialState: PatientState = {
  patients: [],
  loading: false,
  loadingAlertsData: false,
  loadingAlertsHistory: false,
  loadingProfileData: false,
  loadingVitalsData: false,
  vitalsLoading: false,
  error:"",
  patientCount: 0,
  isAddPatient: false,
};

const patientsSlice = createSlice({
  name:"patients",
  initialState,
  reducers: {
    getSinglePatient(state: PatientState, action: PayloadAction<PatientState>){
      state.loading = true;
    },
    getSinglePatientSuccess(state: PatientState, action: PayloadAction<PatientModel>){
      state.loading = false;
      state.patients = {...state.patients, ...action.payload};
    },
    getSinglePatientFailed(state: PatientState, action: PayloadAction<string>){
      state.loading = false;
      state.error = action.payload;
    },
    
    addPatients(state: PatientState, action: PayloadAction<PatientModel>){
      state.loading = true;
    },
    addPatientsMultiple(state: PatientState, action: PayloadAction<PatientModel[]>){
      state.loading = true;
    },
    addPatientsSuccess(state: PatientState, action: PayloadAction<PatientModel>){
      state.loading = false;
      state.patients = [...state.patients, {...action.payload}];
      state.patientCount = state.patientCount+1;
      state.isAddPatient = true;
    },
    addPatientsMultipleSuccess(state: PatientState, action: PayloadAction<PatientModel[]>){
      state.loading = false;
      state.patients = [...state.patients, ...action.payload];
      state.patientCount = state.patientCount+action.payload.length;
      state.isAddPatient = true;
    },
    addPatientsFailed(state: PatientState, action: PayloadAction<string>){
      state.loading = false;
      state.error = action.payload;
    },
    
    updatePatients(state: PatientState, action: PayloadAction<PatientModel[]>){
      state.loading = true;
    },
    updatePatientsSuccess(state: PatientState, action: PayloadAction<PatientModel[]>){
      state.loading = false;
      state.patients = action.payload;
    },
    updatePatientsFailed(state: PatientState, action: PayloadAction<string>){
      state.loading = false;
      state.error = action.payload;
    },
    showLoading(state: PatientState){
      state.loading = true;
    },
    hideLoading(state: PatientState){
      state.loading = false;
    },
    showVitalsLoading(state: PatientState){
      state.vitalsLoading = true;
    },
    hideVitalsLoading(state: PatientState){
      state.vitalsLoading = false;
    },
  }
});

export const patientsActions = patientsSlice.actions;
const patientsReducer = patientsSlice.reducer;
export default patientsReducer;